import { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Menu } from '@headlessui/react';
import { createPopper } from '@popperjs/core';
import { ITipsFeedbackItem, TFeedbackDetailsSection } from '../../../../interfaces/tips-feedback/ITipsFeedback';
import { canManageFeedback } from '../utils';

const FeedbackActions = ({ item, onSelect }: {
    item: ITipsFeedbackItem;
    onSelect?: (item: ITipsFeedbackItem, section: TFeedbackDetailsSection) => void;
}) => {
    const [button, setButton] = useState<HTMLButtonElement | null>(null);
    const [menu, setMenu] = useState<HTMLDivElement | null>(null);
    useLayoutEffect(() => {
        if (!button || !menu) return;
        const popper = createPopper(button, menu, {
            placement: 'bottom-end', strategy: 'fixed',
            modifiers: [{ name: 'offset', options: { offset: [0, 6] } }, { name: 'preventOverflow', options: { padding: 8 } }],
        });
        popper.forceUpdate();
        return () => popper.destroy();
    }, [button, menu]);
    const actions: { section: TFeedbackDetailsSection; label: string }[] = [
        { section: 'details', label: 'See details' },
        { section: 'manage', label: canManageFeedback(item.workflowStatus) ? 'Change status' : 'View resolution' },
        { section: 'analysis', label: 'Analyze feedback' },
        { section: 'investigation', label: 'Leo investigation' },
    ];
    return (
        <Menu as='div' className='inline-flex'>
            <Menu.Button ref={setButton} disabled={!item._id} aria-label={`Actions for ${item.property || item.client || 'feedback'}`}
                className='flex h-11 w-11 items-center justify-center rounded-lg text-gray-800 hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green-700 disabled:opacity-50 dark:text-gray-200 dark:hover:bg-gray-800'>
                <svg aria-hidden='true' width='22' height='22' viewBox='0 0 24 24' fill='currentColor'><circle cx='5' cy='12' r='2' /><circle cx='12' cy='12' r='2' /><circle cx='19' cy='12' r='2' /></svg>
            </Menu.Button>
            {createPortal(
                <Menu.Items ref={setMenu}
                    className='z-40 w-48 rounded-xl border border-gray-200 bg-white p-1.5 shadow-lg focus:outline-none dark:border-gray-700 dark:bg-gray-900'>
                    {actions.map(({ section, label }) => (
                        <Menu.Item key={section}>
                            {({ active }) => <button type='button' onClick={() => onSelect?.(item, section)}
                                className={`min-h-[44px] w-full rounded-lg px-3 py-2 text-left text-sm text-gray-800 dark:text-gray-100 ${active ? 'bg-gray-100 dark:bg-gray-800' : ''}`}>{label}</button>}
                        </Menu.Item>
                    ))}
                </Menu.Items>, document.body,
            )}
        </Menu>
    );
};

export default FeedbackActions;
